import React from 'react';
import { connect } from 'react-redux';

import { Element, Typography } from '@americanexpress/aqx-components';
import DesktopAndTablet from './DesktopAndTablet';

import { getProspectHeroData, getStaticDataForProspectHero } from './redux';
import { getPageData } from 'src/universal/redux/page';

import { summitHeroCustomization as custObj } from './defaultCustomizations';

import styles from './__styles__/index.scss?modules';

const ProspectTabbedHero = ({ content }) => {
  const heroTitle = content?.summitHeroData?.header || '';

  return (
    <Element className={styles.tabbedHeroWrap}>
      <Element className={styles.innerWrap}>
        <Typography
          Component={custObj?.heroTitle?.htmlTag}
          $size={20}
          $lineHeight={'130%'}
          theme={custObj?.heroTitle?.themes?.sm}
          className={styles.heroTitleWrap}
        >
          {heroTitle}
        </Typography>
        <DesktopAndTablet data={content} />
      </Element>
    </Element>
  );
};

const mapStateToProps = state => {
  const prospectHeroData = getStaticDataForProspectHero(state);
  const initialEEP = getPageData(state)?.initialEEP;
  return {
    content: getProspectHeroData(initialEEP, prospectHeroData)(state)
  };
};

export default connect(mapStateToProps)(React.memo(ProspectTabbedHero));
